import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

export default function initBanner() {
  initBannerSwiper();
}

/**
 * Initialize banner slider
 */
function initBannerSwiper() {
  const swiper = new Swiper(".cbb-banner-slider", {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
    },
    loop: true,
    allowTouchMove: false,
    speed: 0,
    modules: [EffectFade, Autoplay],
  });
}